export const info = [
  {
    id: 1,
    title: "Ingeniería contra incendios",
    icono: "../assets/casco.png",
    servicios: [
     
      {
        id: 1,
        nombre: "Habilitación de bomberos",
        descripcion:
         [ "La habilitación de Bomberos es obligatoria para construcciones con fines comerciales, industriales o públicos en Uruguay. Según la Ley N° 15.896, no puede habilitarse una edificación sin la aprobación previa de la Dirección Nacional de Bomberos. Este trámite, que solo puede gestionar un técnico registrado, asegura que el local cumple con las medidas de prevención y protección contra incendios. La habilitación puede caducar ante cambios de uso o modificaciones estructurales. El incumplimiento puede generar multas (entre 10 UR y 200 UR) y responsabilidades penales en caso de siniestros. Contar con este respaldo es clave para operar de forma legal y segura."],
        marca: "",
        imagen: "/assets/habilitacion-bomberos.jpg",
        alt: "habilitaciones-bomberos",
        icon:""
      },
      {
        id: 2,
        nombre: "Sistemas hidráulicos",
        descripcion:["Diseñamos e implementamos sistemas hidráulicos con bocas de incendio, fundamentales para una respuesta manual efectiva ante situaciones de fuego. Nuestro equipo técnico desarrolla soluciones personalizadas, evaluando cada proyecto según las normativas actuales y las particularidades del rubro. Nos encargamos del diseño, planificación y supervisión de obras que incluyen tanques de reserva de gran capacidad, estaciones de bombeo confiables y redes de distribución eficientes. Garantizamos instalaciones seguras, funcionales y ajustadas a los requerimientos de cada cliente."],
        marca: "",
        imagen: "/assets/sistemas-hidraulicos.jpg",
        alt: "sistemas-hidraudicos",
        icon:"FireExtinguisherIcon"
      },
      {
        id: 3,
        nombre: "Sistemas de detección",
        descripcion:["Contamos con una variada gama de soluciones en detección de incendios adaptadas a las necesidades de todos los sectores del mercado. Proveemos los equipos esenciales para el montaje de los sistemas y llevamos a cabo la implementación de tecnologías de detección convencionales, direccionables e inalámbricas. También realizamos controles bimestrales según lo establecido por la normativa, garantizando el rendimiento óptimo y la fiabilidad del sistema instalado."],
        marca: "",
        imagen: "/assets/sistema-deteccion.jpg",
        alt: "sistemas-deteccion",
        icon:"LocalFireDepartmentIcon"
      },
      {
        id: 4,
        nombre: "Planes de evacuación",
        descripcion: ["El Plan de Evacuación es una herramienta clave para salvaguardar la integridad del personal ante cualquier situación de emergencia. Su propósito es garantizar que cada individuo sepa cómo actuar frente a un siniestro, coordinando acciones de forma ordenada y eficiente. Este plan se elabora a partir del análisis detallado del local y su documentación, tomando como referencia normas reconocidas como el Código de Seguridad Humana (NFPA 101). El resultado es un documento técnico adaptado a las características del lugar, que puede incluir recomendaciones específicas para su correcta implementación. Es obligatorio contar con este plan al momento de solicitar la certificación o renovación correspondiente."],
        marca: "",
        imagen: "/assets/evacuacion.jpg",
        alt: "planes-evacuacion",
        icon:"NotificationsActiveIcon"
      },
    ],
  },
  {
    id: 2,
    title: "Tomas aereas con dron",
    icono: "/assets/drone.png",
    servicios: [
      {
        id: 1,
        nombre: "Inmobiliarias",
        descripcion:
         [ "Destaca las características de la propiedad desde otra perspectiva"],
        marca: "",
        imagen: "/assets/portero.png",
        alt: "porteros-electricos",
        icon:""
      },
      {
        id: 2,
        nombre: "Generación de contenido",
        descripcion:
          ["Contenido original para conectar con tu público"],
        marca: "",
        imagen: "/assets/cerradura-magnetica.png",
        alt: "cerraduras-electronicas",
        icon:""
      },
      {
        id: 3,
        nombre: "Destaca los resultados de tu empresa",
        descripcion:
        ["Muestra obras realizadas por tu empresa o emprendimiento desde otra óptica "],
        marca: "",
        imagen: "/assets/video-porteros.png",
        alt: "video-portero",
        icon:""
      },
      {
        id: 4,
        nombre: "Inspecciones de obras",
        descripcion:
        ["Sigue el progreso de tu obra"],
        marca: "",
        imagen: "/assets/video-porteros.png",
        alt: "video-portero",
        icon:""
      },
      {
        id: 5,
        nombre: "Eventos",
        descripcion:
        ["Filmación de eventos "],
        marca: "",
        imagen: "/assets/video-porteros.png",
        alt: "video-portero",
        icon:""
      },
      {
        id: 6,
        nombre: "Edición de video",
        descripcion:
        ["Filmación de eventos "],
        marca: "",
        imagen: "/assets/video-porteros.png",
        alt: "video-portero",
        icon:""
      }
    ],
  },
];
